import React from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FormField } from '~/components/FormField';
import Spinner from '~/components/Spinner/Spinner';
import Breadcrumbs from '~/components/Breadcrumbs/Breadcrumbs';
import Spacer from '~/components/Spacer/Spacer';
import { FormInputConfig } from '~/types/residentManagement';
import usePmReferralOffer, {
  IPmReferralFormData
} from '~/hooks/building/referral/usePmReferralOffer';
import '../CreateEditReferralForm/CreateEditReferralForm.css';

export const ManageReferralProgram = () => {
  const { buildingId } = useParams<{ buildingId: string }>();

  const {
    loader,
    referralOffer,
    pmReferralFormConfig,
    register,
    handleSubmit,
    errors,
    control,
    isDirty,
    saveError,
    referralsTurnedOff,
    submitPmReferralOffer
  } = usePmReferralOffer(buildingId);

  const onSubmit = (formData: IPmReferralFormData) => {
    if (!isDirty) {
      toast('Please edit the form');

      return;
    }

    submitPmReferralOffer(formData);
  };

  const generateField = (fieldConfig: FormInputConfig) => (
    <div key={fieldConfig.id}>
      <div className='create-referral-item'>
        {!!fieldConfig?.label && (
          <label htmlFor={fieldConfig.id}>{fieldConfig.label}</label>
        )}
        <FormField
          fieldConfig={fieldConfig}
          errors={errors}
          register={register}
          control={control}
        />
      </div>
    </div>
  );

  return (
    <div className='container'>
      <Breadcrumbs />
      <div className='float-spinner-parent'>
        {loader && <Spinner float />}
        <Spacer height={24} />
        <div className='title bold'>
          {referralOffer
            ? 'Manage Referral Program'
            : 'Set Up Referral Program'}
        </div>
        <Spacer height={24} />
        {referralsTurnedOff ? (
          <div className='margin-left-16' role='alert'>
            Referrals were turned off for this building by Cobu. Please contact
            your Cobu team to turn them back on before setting up a referral
            program.
          </div>
        ) : (
          <form id='form-container' onSubmit={handleSubmit(onSubmit)}>
            <div className='create-referral-grid'>
              {pmReferralFormConfig.map((field) => generateField(field))}
            </div>
            <Spacer height={20} />
            {!!saveError && (
              <div className='errorTitle margin-left-16' role='alert'>
                {saveError}
              </div>
            )}
            <button
              className='btn-standard btn-primary margin-left-16'
              type='submit'
            >
              Save
            </button>
          </form>
        )}
      </div>
    </div>
  );
};
